module.exports = __webpack_public_path__ + "img/21_32.bc9f36af.png";